// import logo from './logo.svg'
import './App.scss'
import Home from './component/Home'
import { Route, Routes } from 'react-router-dom'
import Layout from './component/Layout'
import About from './component/About'
import Contact from './component/Contact'

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
        </Route>
      </Routes>
    </>
  )
}

export default App
